// Thin wrapper around authenticatedFetch for /api/klaviyo-profile-cleanup. Mirrors ItAssets/apiClient.js.
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/klaviyo-profile-cleanup';

async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    try { const j = await resp.json(); detail = typeof j.detail === 'string' ? j.detail : ''; } catch { /* the status is enough */ }
    throw new Error(detail || `${resp.status} ${resp.statusText}`);
  }
  return resp.json();
}
const qs = (o) => {
  const p = new URLSearchParams();
  Object.entries(o || {}).forEach(([k, v]) => { if (v !== '' && v !== null && v !== undefined && v !== false) p.set(k, v); });
  const s = p.toString();
  return s ? `?${s}` : '';
};
const send = (method, path, body) => authenticatedFetch(`${BASE}${path}`, { method, headers: { 'Content-Type': 'application/json' }, body: body === undefined ? undefined : JSON.stringify(body) }).then(jsonOrThrow);
const get = (path, params) => authenticatedFetch(`${BASE}${path}${qs(params)}`).then(jsonOrThrow);

export const kpcApi = {
  overview: () => get('/overview'),
  segments: () => get('/segments'),
  runs: () => get('/runs'),
  run: (body) => send('POST', '/run', body),
  rules: (p) => get('/rules', p),
  addRule: (b) => send('POST', '/rules', b),
  editRule: (id, b) => send('PATCH', `/rules/${id}`, b),
  deleteRule: (id) => send('DELETE', `/rules/${id}`),
  testValue: (value) => send('POST', '/rules/test', { value }),
  clubs: (p) => get('/clubs', p),
  addClub: (b) => send('POST', '/clubs', b),
  editClub: (id, b) => send('PATCH', `/clubs/${id}`, b),
  deleteClub: (id) => send('DELETE', `/clubs/${id}`),
  approveClub: (b) => send('POST', '/clubs/approve', b),
  invalid: (p) => get('/invalid', p),
  refreshInvalid: () => send('POST', '/invalid/refresh'),
  changes: (p) => get('/changes', p),
  changesCsv: async (p) => { const r = await authenticatedFetch(`${BASE}/changes.csv${qs(p)}`); if (!r.ok) await jsonOrThrow(r); return r.blob(); },
  codisto: () => get('/codisto'),
  codistoPreview: () => send('POST', '/codisto/preview'),
  codistoDelete: () => send('POST', '/codisto/delete'),
};
